<template>
  <div id="ruleCertificationForm">
    <div class="text-h6" v-if="requirementIds && requirementIds.length > 0 && requirement">
      Requirement: {{ requirement.name }}
    </div>
    <div v-else>
      Requirement is not found
    </div>
    <v-form
      v-if="loaded"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-select
        :disabled="requirement.used" 
        v-model="ruleCertification.type"
        :items="types"
        :rules="[rules.required]"
        label="Type"
        clearable
      ></v-select>

      <div class="d-flex flex-column flex-md-row">
        <v-text-field
          :disabled="requirement.used" 
          v-model="ruleCertification.validationPeriod"
          label="Valid Period"
          :rules="[rules.required]"
          :required="false"
        />

        <v-select
          :disabled="requirement.used" 
          class="ml-md-4"
          v-model="ruleCertification.validationPeriodUnit"
          :items="validationPeriodUnits"
          :rules="[rules.required]"
          label="Validation Period Unit"
        ></v-select>
      </div>

      <v-divider class="my-5" />
      <div class="my-4 d-flex justify-space-between">
        <v-btn @click="goBack">
          Back
        </v-btn>
        <v-btn :disabled="requirement.used" @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>

<script>
import { getRuleCertification } from "@/services/ruleCertification";

import { getRequirement } from "@/services/requirement";

import { mapActions } from "vuex";
import Axios from "axios";

import { rules } from "@/store/util/rules.js";

export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: null
    },
    requirementIds: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      id: null,
      loaded: false,
      valid: false,
      types: ["Resume", "Education Degree", "Medical", "Others"],
      validationPeriodUnits: ["Days", "Months", "Years"],
      requirement: null,
      ruleCertification: {
        id: null,
        type: "",
        validationPeriod: null,
        validationPeriodUnit: "",
        requirementId: null
      },
      rules
    };
  },
  created() {
    if(this.value){
      this.id = this.value.id;
    }
    
    if (this.requirementIds && this.requirementIds.length > 0) {
      const requirementId = this.requirementIds[0];
      getRequirement(requirementId).then(resp => {
        this.requirement = resp.data;
        this.ruleCertification.requirementId = this.value.requirementId;

        this.setInstance();
      });
    }
  },
  methods: {
    ...mapActions("ruleCertification", [
      "createRuleCertification",
      "updateRuleCertification"
    ]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage"
    ]),

    async handleSubmit() {
      if (!this.$refs.form.validate()) {
        this.addErrorMessage("Please check your inputs");
        return;
      }

      if (this.id) {
        let ruleCertification = this.ruleCertification;

        this.updateRuleCertification(ruleCertification)
          .then(response => {
            console.log(response);
            this.addSuccessMessage(
              "Certification rule was updated successfully"
            );
            this.$router.push({name: 'requirementView', params: {id: this.requirement.id}})
          })
          .catch((error) => {
            console.log(error);
            this.addErrorMessage(
              "Error updating certification rule, please try again later"
            );
          });
      } else {
        const requests = [];
        for(const requirementId of this.requirementIds){
          let ruleCertification = Object.assign({}, this.ruleCertification);
          ruleCertification.requirementId = requirementId;
          const createRequest = this.createRuleCertification(ruleCertification)
          requests.push(createRequest);
        }

        Axios.all(requests)
          .then(Axios.spread((...responses) => {
            this.addSuccessMessage(
              "Certification rule was created successfully"
            );
            if(responses.length == 1){
              this.$router.push({name: 'requirementView', params: { id: responses[0].requirementId }})
            }
            else{ 
              this.$router.push({name: 'requirement'})
            }
          }))
          .catch(() => {
            this.addErrorMessage(
              "Error creating certification rule, please try again later"
            );
          });
      }
    },
    goBack(){
      this.$emit('goBack', this.ruleCertification);
    },
    setInstance() {
      if (this.id) {
        this.ruleCertification.id = this.id;
        getRuleCertification(this.id).then(response => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(
                this.ruleCertification,
                property
              )
            ) {
              this.ruleCertification[property] = instance[property];
            }
          }
          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
    }
  },
  components: {}
};
</script>
